module.exports = __webpack_public_path__ + "static/media/noun_Question_727759.514492c6.svg";